module.exports = __webpack_public_path__ + "wsWorker.worker.js"